import { useCookies } from '@edikk-edikk/di-container';
import { useMemo } from 'react';
import trimStart from 'lodash.trimstart';
import { useLocation } from 'react-router';
import { AGE_GATE_COOKIE_NAME } from '#baseAgeGate/constants';
import { useBaseContext } from '#base/hooks/use-base-context';

const useIsVisible = () => {
  const { ageGate } = useBaseContext();
  const cookies = useCookies();
  const { pathname } = useLocation();

  return useMemo(() => {
    if (cookies.getCookies().get(AGE_GATE_COOKIE_NAME)) {
      return false;
    }

    if (!ageGate.isEnable || !ageGate.description) {
      return false;
    }

    const preparedPathname = trimStart(pathname, '/');
    return ageGate.excludePageList.every((excludePage) => {
      const preparedExcludePage = trimStart(excludePage, '/');
      return preparedPathname !== preparedExcludePage;
    });
  }, [ageGate, cookies, pathname]);
};

export { useIsVisible };
